module.exports = __webpack_public_path__ + "img/C.d222c93.jpg";